module.exports = __webpack_public_path__ + "media/ding.62a2cb8c.mp3";